import { render, staticRenderFns } from "./hotelDetails.vue?vue&type=template&id=e5eaadda"
import script from "./hotelDetails.vue?vue&type=script&lang=js"
export * from "./hotelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports